import React from 'react';
import { FormattedMessage } from 'react-intl';
import InlineTabsLayout from './inlineTabs';
import { PageDevice } from 'src/consts/routes';

const MODULE = PageDevice.slice(1);

const TABS = [
  {
    key: 'all',
    name: 'All Devices',
    foreign_name: '所有设备',
  },
  {
    key: 'printers',
    name: 'Printers',
    foreign_name: '打印机',
  },
  {
    key: 'printer-logs',
    name: 'Printer Logs',
    foreign_name: '打印日志',
  },
];

const DeviceLayout = ({ children }) => (
  <InlineTabsLayout module={MODULE} title={<FormattedMessage id="devices.title" />} tabs={TABS}>
    {children}
  </InlineTabsLayout>
);

export default DeviceLayout;
